import { render, staticRenderFns } from "./CustomerRecord.vue?vue&type=template&id=8d325a06&scoped=true"
import script from "./CustomerRecord.vue?vue&type=script&lang=js"
export * from "./CustomerRecord.vue?vue&type=script&lang=js"
import style0 from "./CustomerRecord.vue?vue&type=style&index=0&id=8d325a06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d325a06",
  null
  
)

export default component.exports